import React, { useEffect } from "react";
import { FooterFPText, FPFooterWrapper } from "../StyledComponent";
import ScrollButton from "../UpwardScrollButton";
import Counter from "./Counter";
import { useTranslation } from "react-i18next";

const FastPasFooter = () => {
  const { t } = useTranslation();
  const meetUrl =
    "https://teams.microsoft.com/l/meetup-join/19%3ameeting_MjVkYWM4YjktMTY3NS00NzdlLWEzYjItNzRjNDg3NjYzODY4%40thread.v2/0?context=%7b%22Tid%22%3a%223c662ad3-b258-4418-a5f0-218389e2223d%22%2c%22Oid%22%3a%22610dd1a6-83e5-40fa-b1f6-b472a94773e7%22%7d";
  return (
    <FPFooterWrapper>
      <div
        style={{
          position: "absolute",
          left: "15px",
          fontSize: "12px",
          fontWeight: "bold",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "4px",
        }}
      >
        <strong style={{ fontSize: "12px" }}>{t("FASTPAS.HOME.FOOTER.CONTACT_US_NUMBER")}</strong>

        <span>
          Training Meet Link:{" "}
          <a className="click-here-anchor" href={meetUrl} target="_blank" rel="noreferrer">
            Click Here
          </a>{" "}
          (Every Wednesday & Friday 3:00pm to 5:00pm)
        </span>
      </div>

      <p style={{ textAlign: "center", fontSize: "12px" }}>
        <span style={{ fontSize: "11px" }}> © Copyright </span>
        <strong>AWAS BANDHU.</strong>
      </p>

      <FooterFPText>
        {/* <p>
          This is the official Website of UP Housing & Development Board, State Government of Uttar Pradesh, India. Content on this website is
          published and ‘managed’ by UP Housing & Development Board, State Government of Uttar Pradesh. For any query regarding this website, please
          contact the "Web Information Manager".
        </p>
        <span>Total visitor counter:</span> */}
        <Counter />
      </FooterFPText>

      <ScrollButton />
    </FPFooterWrapper>
  );
};

export default FastPasFooter;
